
export function getRuteBackend() {
	return "";
}

export function getRuteLogin() {
	return "https://ecommerce.zadrigman.com/login";
	//return "http://localhost:3000/login";
}

export function getRuteTY() {
	return "https://ecommerce.zadrigman.com/ty";
	//return "http://localhost:3000/ty";
}

export function openViewCharge() {
	document.getElementById('screenBlackAll').style.display = "";
	document.getElementById('carga').style.display = "";
}

export function closeViewCharge() {
	document.getElementById('screenBlackAll').style.display = "none";
	document.getElementById('carga').style.display = "none";
}

export function createAlert(array) {
	let type = array.type;
	let msg_title = array.msg_title;
	let msg = array.msg;
	let effect = array.effect;
	let time_life = array.time_life;
	let post_action = array.post_action;

	let container_adv = document.getElementById("alertas-adv");
	let plantilla = document.getElementById('plantilla-advertencia-' + type);
	let advertencia = plantilla.cloneNode(true);
	advertencia.style.display = "";
	advertencia.style.animation = effect;
	advertencia.querySelector('.title-advertencia').innerHTML = msg_title;
	advertencia.querySelector('.subtitle-advertencia').innerHTML = msg;
	advertencia.setAttribute('action', post_action);

	container_adv.appendChild(advertencia);

	if (time_life) setTimeout(function () {
		let action = advertencia.getAttribute('action');
		if (action) {
			let button = document.createElement('button');
			button.setAttribute('onclick', action);
			button.click();
			button.remove();
		}

		advertencia.remove();
	}, time_life);
}

export function copyText(text) {
	let input = document.getElementById('copy-text-input');
	input.value = text;

	input.select();
	document.execCommand('copy');

	createAlert({ type: "success", msg_title: "Copiado", msg: "Se copio contenido en el portapapeles", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
}

export function isAuthenticated() {
    return !!localStorage.getItem('session_id') && !!localStorage.getItem('keylogin') && !!localStorage.getItem('code_confirm');
}

export function get_session_id() {
    return localStorage.getItem('session_id');
}

export function get_keylogin() {
    return localStorage.getItem('keylogin');
}

export function get_user() {
	if(localStorage.getItem('user'))
		return JSON.parse(localStorage.getItem('user'));
	else return [];
}

export async function validateSession() {
    let path_api = localStorage.getItem('path_api');
	
	await fetch(`${path_api}/admin/validate_session.php`, {
		method: 'POST',
		headers: {'Content-Type': 'application/json'},
		body: JSON.stringify({
            rute: getRuteBackend(),
            session_id: get_session_id(),
            keylogin: get_keylogin(),
		}),
	}).then(function(response){
		if(response.ok){
			response.json().then(function(json){
				if(json.mensaje == "No hay una sesion iniciada" || json.mensaje == "No se encontro una sesion activa"){
					localStorage.removeItem('session_id');
					localStorage.removeItem('keylogin');
					localStorage.removeItem('code_confirm');
					localStorage.removeItem('user');
                    window.setTimeout(function(){
                        window.location.href = getRuteLogin();
                    }, 1000);
                }else if(json.mensaje == "success"){
					localStorage.setItem('user', JSON.stringify(json.user));
				}
			})
		}
	});
}

export function getCookieValue(name) {
	const cookie = document.cookie.split(";").find(c => c.trim().startsWith(name + "="));
	return cookie ? cookie.split("=")[1].trim() : null;
}

export function facebookParams() {
	let event_time = new Date();

	let fbp = document.cookie.split(";").filter(function(c) {
		return c.includes("_fbp=")
	}).map(function (c) {
		return c.split("_fbp=")[1];
	});

	if(fbp[0]) fbp = fbp[0];
	if(!fbp.length) fbp = null;

	let fbc = document.cookie.split(";").filter(function(c) {
		return c.includes("_fbc=")
	}).map(function (c) {
		return c.split("_fbc=")[1];
	});

	if(fbc[0]) fbc = fbc[0];
	if(!fbc.length) fbc = null;
	
	if (!fbp || fbp.length === 0)
		fbp = getCookieValue("_fbp");
	if (!fbc || fbc.length === 0)
		fbc = getCookieValue("_fbc");

	if (!fbp || fbp.length === 0) fbp = null;
	if (!fbc || fbc.length === 0) fbc = null;

	return {
		event_source_url: window.location.href,
		client_user_agent: navigator.userAgent,
		event_time: Math.round(event_time.getTime()/1000),
		facebookPixel: "1791112601665308",
		facebookToken: "EAAIjmEi9otsBO8BdYiK3HPf1ofV7bOZC8JATTrfa67dZAM7c2aMPxIPDkl5ZC4O569cHTu99Ddnn1nqa0MuDIubNprtRlP9Nprc0Og8yW2lvkYdt0dd9uG51hkbBnrl8tXgZBoJCmtZAk1CTOjl3g3rmuOx2cru6DnSnGe6iLRXZBs70VAGkCRlDwIBYme3PlF3k3JtQZDZD",
		event_id: Math.random().toString(36).substring(2) + Date.now().toString(36),
		fbp: fbp,
		fbc: fbc
	};
}